import classNames from 'classnames'

import { type TMainCategoryData } from '@/app/types/servicesTypes'
import { Button, Divider, Modal } from '@/shared'

import style from './RemoveCategoryModal.module.scss'

interface IAction {
    title: 'Удалить' | 'Отменить'
    color: 'blue' | 'red'
    disabled: boolean
    callback: () => void
}

interface IProps {
    removableCategory: TMainCategoryData
    onClose: () => void
    onRemoveCategory: (id: string, onSuccess: () => void) => void
}

export const RemoveCategoryModal = (props: IProps) => {
    const { removableCategory, onClose, onRemoveCategory } = props

    const onCancelRemovementCallback = () => {
        onClose()
    }

    const onRemoveCategoryCallback = () => {
        onRemoveCategory(removableCategory.id, onCancelRemovementCallback)
        onCancelRemovementCallback()
    }

    const actions: IAction[] = [
        { title: 'Удалить', color: 'blue', disabled: false, callback: onRemoveCategoryCallback },
        { title: 'Отменить', color: 'red', disabled: false, callback: onCancelRemovementCallback }
    ]

    const warningRemove = `Категория "${removableCategory.name}" будет безвозвратно удалена и все имеющтеся услуги внутри нее будут перенесены в категорию "Иные услуги". \nЗаранее убедитесь что нет услуг которые должны быть отображены клиенту.`

    return (
        <Modal show={!!removableCategory} onClose={onCancelRemovementCallback}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Удалить Категорию</span>
                </div>
                <div className={style.content}>
                    <span>{warningRemove}</span>
                </div>
                <Divider />
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, color, disabled, callback } = action
                        return (
                            <Button
                                key={title}
                                className={classNames(style.btn, style[color])}
                                onClick={callback}
                                disabled={disabled}
                            >
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
